import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { hasPermission } from '../utils/permissionUtils';
import toast from 'react-hot-toast';

const ProtectedRoute = ({ children, requiredPermission }) => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if user has token
    const token = localStorage.getItem('token');
    if (!token) {
      toast.error('Please login to access this page');
      navigate('/');
      return;
    }

    // Check if user has required permission
    if (requiredPermission && !hasPermission(requiredPermission)) {
      toast.error('You do not have permission to access this page');
      // Redirect to home page if no permission
      navigate('/home');
      return;
    }
  }, [navigate, requiredPermission]);

  return children;
};

export default ProtectedRoute; 